import { applySubmitInput } from "@cloudnest/stone-flicking-core-engine/appliers";
import type { SubmitFlickAction } from "../types/actions";
import type { StoneFlickingState } from "../types/game-state";
import { toParticipantId, wrapCoreState } from "../utils/state-mapper";

export function applySubmitFlick(
  state: StoneFlickingState,
  action: SubmitFlickAction,
): StoneFlickingState {
  const coreAction = {
    type: "SUBMIT_INPUT" as const,
    participantId: toParticipantId(action.playerId),
    entityId: action.entityId,
    impulse: action.impulse,
  };

  const nextCoreState = applySubmitInput(state.coreState, coreAction);
  return wrapCoreState(nextCoreState);
}
